jQuery(document).ready(function(){
	jQuery("#slidemenuopen").click(function(){
		console.log('open');
		jQuery("#slidemenuback").addClass("toggle");
		jQuery("#slidemenusection").addClass("toggle");
	});
	jQuery("#slidemenuopend").click(function(){
		jQuery("#slidemenuback").addClass("toggle");
		jQuery("#slidemenusection").addClass("toggle");
	});

	jQuery("#slidemenuclose").click(function(){
		jQuery("#slidemenuback").removeClass("toggle");
		jQuery("#slidemenusection").removeClass("toggle");
	});
	jQuery("#slidemenuback").click(function(){
		jQuery("#slidemenuback").removeClass("toggle");
		jQuery("#slidemenusection").removeClass("toggle");
	});
});
